import { render, staticRenderFns } from "./cModalClasifPharmacy.vue?vue&type=template&id=3f0228b0"
import script from "./cModalClasifPharmacy.vue?vue&type=script&lang=js"
export * from "./cModalClasifPharmacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports